import moment from 'moment'
import store from '../redux/store'

export const sortedArray = (arr) => {
  return arr?.sort((a, b) => {
    const positionOrder = {
      LW: 1,
      C: 2,
      RW: 3,
      D: 4,
      G: 5,
    }
    const positionComparison =
      positionOrder[a?.player_id?.Position] - positionOrder[b?.player_id?.Position]
    const nameComparison = a?.player_id?.Name.localeCompare(b?.player_id?.Name)
    return positionComparison !== 0 ? positionComparison : nameComparison
  })
}

export const sortedArrayCap = (arr) => {
  return arr?.sort((a, b) => {
    const capComparison = b?.player_id?.PlayerCap - a?.player_id?.PlayerCap
    return capComparison
  })
}

export const firstLetterCap = (str) => {
  return str !== '' ? str?.charAt(0).toUpperCase() + str.slice(1) : str
}

export const getAge = (d) => {
  const birthDate = moment(d)
  const currentDate = moment()
  const Age = currentDate.diff(birthDate, 'years')
  return Age
}

export const checkWaiver = (_age, _gamesPlayed, Position) => {
  const age = getAge(_age)
  const gamesPlayed = _gamesPlayed > 0 ? _gamesPlayed : 0
  return age >= 25
    ? false
    : age >= 18 && age <= 20 && gamesPlayed < 160 && Position !== 'G'
    ? 160 - gamesPlayed
    : age >= 18 && age <= 20 && gamesPlayed < 80 && Position === 'G'
    ? 80 - gamesPlayed
    : age === 21 && gamesPlayed < 80 && Position !== 'G'
    ? 80 - gamesPlayed
    : age === 21 && gamesPlayed < 60 && Position === 'G'
    ? 60 - gamesPlayed
    : age === 22 && gamesPlayed < 70 && Position !== 'G'
    ? 70 - gamesPlayed
    : age === 22 && gamesPlayed < 60 && Position === 'G'
    ? 70 - gamesPlayed
    : age >= 23 && age <= 24 && gamesPlayed < 60
    ? 60 - gamesPlayed
    : age === 23 && age <= 24 && gamesPlayed < 60
    ? 60 - gamesPlayed
    : false
}

export const getPfScore = (arr) => {
  const season = store?.getState()?.user?.setting?.season
  const pf = arr?.filter((v) => v?.season == season)?.reduce((acc, obj) => acc + obj.score, 0) || 0
  const avg = pf > 0 ? pf / arr?.length : 0
  return {
    pf: pf?.toFixed(2),
    avg: avg?.toFixed(2),
  }
}

export const getPf = (arr) => {
  if (arr && arr?.length > 0) {
    const setting = store?.getState()?.user?.setting
    const filtered = arr.filter((v) => v?.season === setting?.season && v?.date <= setting?.date)
    const tpf = filtered?.reduce((acc, obj) => acc + obj.score, 0) || 0

    // filtered array with score greater than zero
    const filteredArr = arr.filter((item) => item?.score > 0)

    const apf = tpf > 0 ? tpf / filteredArr?.length : 0
    return {
      tpf: tpf?.toFixed(2),
      apf: apf?.toFixed(2),
    }
  } else {
    return {
      tpf: Number(0).toFixed(2),
      apf: Number(0).toFixed(2),
    }
  }
}

export const getRankAndPosition = (arr) => {
  const obj = {
    playerOverallRank: 'N/A',
    playerPositionRank: 'N/A',
  }
  if (arr && arr?.length > 0) {
    const setting = store?.getState()?.user?.setting
    const isExist = arr.find((v) => v?.season === setting?.season && v?.date === setting?.date)
    const overall = isExist?.playerOverallRank
    const position = isExist?.playerPositionRank

    if (isExist) {
      obj.playerOverallRank = overall <= 0 ? 'N/A' : `#${overall}`
      obj.playerPositionRank = position <= 0 ? 'N/A' : `#${position}`
    }
  }
  return obj
}

// const areArraysEqual = (arr1, arr2) => {
//   const sortedArr1 = arr1.slice().sort()
//   const sortedArr2 = arr2.slice().sort()
//   for (let i = 0; i < arr1.length; i++) {
//     if (sortedArr1[i] !== sortedArr2[i]) {
//       return false
//     }
//   }
//   return true
// }

export const isDraftStart = (date) => {
  const givenDate = new Date(date)
  const currentDate = new Date()
  return givenDate < currentDate
}

export const getRemainingSeconds = (timeString) => {
  const givenTime = new Date(timeString)
  const currentTime = new Date()
  const timeDifference = givenTime - currentTime
  const remainingSeconds = Math.floor(timeDifference / 1000)
  return remainingSeconds > 0 ? remainingSeconds : 0
}
